import { type IRates, type Source } from '../types'
import { formatCurrency } from './format-currency-from-cents.ts'

export const formatRate = (rates?: IRates, source?: Source) => {
  if (!rates) return ''
  if (!source && !process.env.SOURCE) return ''

  source = source ?? (process.env.SOURCE as Source)

  const sourceCurrency = {
    'cargoking-shipper': {
      char: '€',
      code: 'EUR',
    },
    kcharles: {
      char: '£',
      code: 'GBP',
    },
  }

  const currency = sourceCurrency[source]

  const rate = rates[currency.code as keyof IRates]

  return currency.char + ' ' + formatCurrency(rate.rate)
}
